import { useMutation } from '@tanstack/react-query';
import type { CandidateBoardDeleteRequest } from '../types/CandidateBoard';

export default function useDeleteCandidateBoard() {
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement).content;
  return useMutation({
    mutationFn: async ({ targetBoardId }: CandidateBoardDeleteRequest) => {
      const response = await fetch(`/agent/api/candidate_boards/${targetBoardId}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-CSRF-Token': token,
        },
        body: JSON.stringify({}),
      });
      const data = await response.json();
      return data;
    },
  });
}
